import { Component } from '@angular/core';

@Component({
  selector: 'app-detail-teregistrasi-registered',
  templateUrl: './detail-teregistrasi-registered.component.html',
  styleUrls: ['./detail-teregistrasi-registered.component.scss']
})
// Detail Menunggu KUL
export class DetailTeregistrasiRegisteredComponent {

}
